import React from "react";

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch, useSelector } from "react-redux";
import { resetRunState } from "../../reducers/runReducer";
import Switch from '@mui/material/Switch';
import { getAllVehicle } from "../../reducers/vehicleReducer";
import { createNewWhs } from "../../reducers/whsReducer";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";
import useRudderStackAnalytics from "../../config/useRudderAnalytics";
export default function WHSCreateReport(){
    const useRudderAnalytics=useRudderStackAnalytics();
    const driverName=useSelector(state=>state.driver.entities.currDriver?.driverName);
    const driverId=useSelector(state=>state.driver.entities.currDriver?.driverId);
    const driverJobTitle=useSelector(state=>state.driver.entities.currDriver?.driverJobTitle);
    const site=useSelector(state=>state.driver.entities.currDriver?.site);
    const navigate=useNavigate()
    const vehicle=useSelector(state=>state.vehicle.entities.vehicleList);
    const whsNavigation=useSelector(state=>state.whs.entities.whsNavigation);
    const whsError=useSelector(state=>state.whs.entities.error);
    const [isSubmit, setSubmit]=React.useState(false);
    const [formData, setFormData]=React.useState({
       date:dayjs(),
       deliveryDate:dayjs(),
       site: "",
       driver: "",
       driverId:"",
       vehicle:"",
       odometer:"",
       serviceDueKm:"",
       visualInspection:false,
       visualInspectionComment:"",
       interiorClean:false,
       exteriorClean:false,
       cleanlinessComment:"",
       firstAid:false,
        version:"v1",
        company:"thefruitbox"
    });
    const vehicleElements=vehicle && vehicle.length>0?vehicle.map((e,i)=><MenuItem sx={{fontSize:"0.8rem", whiteSpace:"normal"}}  value={e.license}>{e.license}</MenuItem>):<MenuItem value={""}>No Vehicle Available</MenuItem>
    const dispatch=useDispatch();
    React.useEffect(()=>{
        if(whsNavigation && whsNavigation.driverId && whsNavigation.date){
            navigate(`/${whsNavigation.driverId}/whs/report/${whsNavigation.date.toString()}`);
        }
    },[whsNavigation, navigate])
    React.useEffect(()=>{
        if(driverName){
            setFormData(prev=>{
                    return {
                        ...prev,
                        driver:driverName,
                        driverId:driverId,
                        site:site
                    }
            })
        }
        //clear run cache
        dispatch(resetRunState())

    },[driverName, dispatch, driverId, site])
    const handleSubmit=async (e)=>{
        e.preventDefault();
        if(dayjs(dayjs(formData.deliveryDate).format("YYYY-MM-DD")).isBefore(dayjs(formData.date).format("YYYY-MM-DD"))){
            window.alert('Inspection Date should not be in the past')    
        }
        else{
            await dispatch(createNewWhs({data:formData, driverId}))
            setSubmit(true);
        }
    }
    React.useEffect(()=>{
        if(isSubmit && window.navigator.onLine && !whsError && useRudderAnalytics) {
            useRudderAnalytics.track("Create Vehicle Inspect", {...formData, date:dayjs(formData.date).format("YYY-MM-DD").toString(), deliveryDate: dayjs(formData.deliveryDate).format("YYYY-MM-DD").toString()})
            window.alert('Vehicle Temperature Report Updated Successfully');
        }
        else if(isSubmit && (!window.navigator.onLine || whsError) && useRudderAnalytics) {
            useRudderAnalytics.track("CreateVehicle Inspect Error", {...formData,date:dayjs(formData.date).format("YYY-MM-DD").toString(), deliveryDate: dayjs(formData.deliveryDate).format("YYYY-MM-DD").toString()})
            window.alert('Something went wrong, please check your connection and try again.')
        }
        setSubmit(false)
    },[whsError, isSubmit, formData, useRudderAnalytics])
    const handleToggleChange=async (e)=>{
        const {checked, name}=e.target;
        setFormData(prev=>{
                return {
                    ...prev,
                    [name]:checked
                }
            })
    }
    
    const handleChange=async (e)=>{
        if (e.$d){
            

            setFormData(prev=>{
                return {
                    ...prev,
                    deliveryDate:dayjs(e.$d)
                }
            })
        }
        else{
            const {name, value}=e.target
            setFormData(prev=>{
                return {
                    ...prev,
                    [name]: value                    
                }
            })
            
        }
    }
    React.useEffect(()=>{
        if(formData.site && driverId){
            dispatch(getAllVehicle({site:formData.site, driverId}))
        }
    },[formData.site, driverId, dispatch]);
    React.useEffect(()=>{
        if(useRudderAnalytics && driverId){
            useRudderAnalytics.page("Create Vehicle Inspect")
        }
    },[useRudderAnalytics, driverId])
    const element=driverId&& !driverJobTitle.toLowerCase().includes("contractor")?            
    <form onSubmit={handleSubmit} className="reportForm">
                <div className="reportField">
                    <h3>Instruction</h3>
                </div>
                <p className="reportField">Complete this form every Monday of the week and return to the Fleet Manager/Supervisor in your state<br/><span style={{fontSize:"0.8rem"}}>The Fleet Manager/Supervisor will investigate any issues that arise.</span></p>
                <div className="reportFieldBackground">
            <FormControl className="reportField">
                <TextField value={formData.site} name="site" onChange={handleChange} disabled label="Site:" variant="outlined" />
            </FormControl>
                </div>
                <div className="reportField">
                    <h3>Operator Details</h3>
                </div>
                <div className="reportFieldBackground">
                <FormControl className="reportField">
                    <TextField value={formData.driver} name="driver" onChange={handleChange} disabled label="Operator:" variant="outlined" />
                </FormControl>
                <FormControl className="reportField">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                        <DatePicker
                            name="deliveryDate"
                            label="Date:"
                            value={formData.deliveryDate}
                            onChange={handleChange}
                            format="DD/MM/YYYY"
                            disablePast
                            required
                        />
                    </DemoContainer>
                </LocalizationProvider>
                </FormControl>
                </div>
                <div className="reportField">
                    <h3>Vehicle Detail</h3>
                </div>
                <div className="reportFieldBackground">
            <FormControl className="reportField">
                <InputLabel id="vehicle">Registration Number:</InputLabel>
                <Select
                    labelId="vehicle"
                    name="vehicle"
                    value={formData.vehicle}
                    label="Registration Number"
                    onChange={handleChange}
                    required
                >
                    {vehicleElements}
                </Select>
            </FormControl>
                <FormControl className="reportField">
                    <TextField
                        value={formData.odometer}
                        name="odometer"
                        type="text" // Use text instead of number
                        required
                        onChange={(e) => {
                        const value = e.target.value;
                        // Allow only empty string or integers
                        if (value === '' || /^\d+$/.test(value)) {
                            handleChange(e);
                        }
                        }}
                        label="Vehicle Odometer Reading:"
                        variant="outlined"
                        inputProps={{
                        inputMode: 'numeric', // still shows number pad on mobile
                        pattern: '[0-9]*'     // helps with some validation
                        }}
                    />
                </FormControl>
            <FormControl className="reportField">
                <TextField
                    value={formData.serviceDueKm}
                    name="serviceDueKm"
                    type="text" // Use text to fully control input
                    required
                    onChange={(e) => {
                    const value = e.target.value;
                    // Allow empty or digits only
                    if (value === '' || /^\d+$/.test(value)) {
                        handleChange(e);
                    }
                    }}
                    label="Service Due Km:"
                    variant="outlined"
                    inputProps={{
                    inputMode: 'numeric', // mobile-friendly
                    pattern: '[0-9]*',    // HTML5 validation hint
                    }}
                />
            </FormControl>
                </div>
                <div className="reportField">
                    <h3>Visual Inpection</h3>
                </div>
                <div className="reportFieldBackground">
                <div className="reportField">
                    <InputLabel>Visual Inspection</InputLabel>
                    <FormControlLabel
                    control={<ButtonSwitch onChange={handleToggleChange} name="visualInspection" checked={formData.visualInspection}/>}
                />
                </div>
                <FormControl className="reportField">
                    <TextField value={formData.visualInspectionComment} name="visualInspectionComment" type="text" onChange={handleChange} label="Visual Inspection Comments:" variant="outlined" />
                </FormControl>
                </div>
                <div className="reportField">
                    <h3>Cleanliness/Tidiness</h3>
                </div>
                <div className="reportFieldBackground">
                     <div className="reportField">
                    <InputLabel>Interior Clean?</InputLabel>
                    <FormControlLabel
                    control={<ButtonSwitch onChange={handleToggleChange} name="interiorClean" checked={formData.interiorClean}/>}
                />
                </div>
                 <div className="reportField">
                    <InputLabel>Exterior Clean?</InputLabel>
                    <FormControlLabel
                    control={<ButtonSwitch onChange={handleToggleChange} name="exteriorClean" checked={formData.exteriorClean}/>}
                />
                </div>
                <FormControl className="reportField">
                    <TextField value={formData.cleanlinessComment} name="cleanlinessComment" type="text" onChange={handleChange} label="Cleanliness Comments:" variant="outlined" />
                </FormControl>
                </div>
                <div className="reportField">
                    <h3>First Aid</h3>
                </div>
                <div className="reportFieldBackground">
                    
                <div className="reportField">
                    <InputLabel>Are you able to locate the First Aid Kit?</InputLabel>
                    <FormControlLabel
                    control={<ButtonSwitch onChange={handleToggleChange} name="firstAid" checked={formData.firstAid}/>}
                />
                </div>
                
                </div>
                <Button type="submit" variant="contained" style={{marginBottom:"10px", marginTop:"10px"}}>Submit</Button>
            </form>:<></>
    return (
        <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
            {element}
        </div>
    )
}
const ButtonSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&::before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&::after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));